import React from "react";
import {IconProps} from "../../../../../icons/icon-props-interface";

const IconBook: React.FC<IconProps> = ({ color = 'var(--color-primary-2-50)' }) => {
    return (
        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.93333 14.4694C7.23333 14.5901 7.55556 14.339 7.55556 13.9767V1.98116C7.55556 1.84767 7.51111 1.71417 7.41667 1.63153C6.87222 1.13569 5.62222 0.5 4 0.5C2.59722 0.5 1.28611 0.922736 0.502778 1.26601C0.188889 1.40586 0 1.76185 0 2.14645V13.9163C0 14.2945 0.355556 14.5584 0.669444 14.4407C1.54444 14.107 2.93056 13.7224 4 13.7224C4.94167 13.7224 6.19444 14.1674 6.93333 14.4694ZM9.06667 14.4694C9.80556 14.1674 11.0583 13.7224 12 13.7224C13.0694 13.7224 14.4556 14.107 15.3306 14.4407C15.6444 14.5615 16 14.2945 16 13.9163V2.14645C16 1.76185 15.8111 1.40586 15.4972 1.26919C14.7139 0.922736 13.4028 0.5 12 0.5C10.3778 0.5 9.12778 1.13569 8.58333 1.63153C8.49167 1.71417 8.44444 1.84767 8.44444 1.98116V13.9767C8.44444 14.339 8.76944 14.5901 9.06667 14.4694Z"
                fill={color}
            />
        </svg>
    );
}

export default IconBook;